import { render, staticRenderFns } from "./FormNotification.vue?vue&type=template&id=51408c86&scoped=true&"
import script from "./FormNotification.vue?vue&type=script&lang=js&"
export * from "./FormNotification.vue?vue&type=script&lang=js&"
import style0 from "./FormNotification.vue?vue&type=style&index=0&id=51408c86&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51408c86",
  null
  
)

export default component.exports